<template>
    <div>
        <div class="ach-context" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="!shownull">
            <div class="per-line" v-for="(e, i) in pageData" :key="i">
                <div class="flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center">
                        <img :src="e.avatar_url || moren" class="item-avatar"/>
                        <p class="item-name">{{e.true_name || e.nickname || '-'}}</p>
                    </div>
                    <p class="item-time">{{e.pay_time}}</p>
                </div>
                <div class="flex flex-j-c-sb flex-a-i-center">
                    <p class="item-text">报考#{{e.first_name}}-{{e.goods_name}}专业#</p>
                    <p class="item-num">+{{e.percentage}}</p>
                </div>
            </div>
        </div>
        <DataNull v-if="shownull"/>
        <Nomore v-if="showNoMore"/>
    </div>
</template>

<script>
import DataNull from '@/components/DataNull';
import {getAchievement} from '@/api';
import { Indicator, MessageBox, Toast } from 'mint-ui';
import Nomore from '@/components/Nomore';

export default {
  name: 'AchiPre',
  components: {
    DataNull,
    Nomore
  },
  data() {
    return {
      pageData: [], // 个人业绩数据
      loading: true,
      page: 1, // 页数
      shownull: false,
      moren: require('@/assets/avatar.png'),
      showNoMore: false
    }
  },
  created() {
    this.getAchievementList();
  },
  methods: {
    //到底加载
    loadMore(){
      if (this.loading) return false;
      this.loading = true
      this.page += 1;
      this.getAchievementList();
    },
    // 获取个人业绩列表
    getAchievementList() {
      getAchievement({page: this.page, limit: 10}).then(res => {
        if (res.code === 0) {
          this.pageData = this.pageData.concat(res.data);
          if (res.data.length === 0) { this.shownull = true };
          if (res.data.length === 10) { this.loading = false };
          if (res.data.length !== 10 && res.data.length !== 0) { this.showNoMore = true };
          if (Number(res.totalCount) === this.pageData.length) { this.loading = true;this.showNoMore = true };
        } else {
          this.shownull = true 
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.ach-context{
        border-top: 0.54rem solid #f6f6fa;
        background: white;
        padding: 0 0.16rem;
            &>:last-child{
                border: none;
            }
            .per-line{
                height: auto;
                line-height: 0.4rem;
                padding: 0.1rem 0;
            }
            .item-avatar{
                width: 0.23rem;
                height: 0.23rem;
                margin-right: 0.12rem;
                border-radius: 50%;
            }
            .item-name{
                font-size: 0.16rem;
            }
            .item-time{
                color: #999999;
                font-size: 0.12rem;
            }
            .item-text{
                font-size: 0.14rem;
                color: #333333;
                width: 75%;
                text-align: left;
            }
            .item-num{
                font-size: 0.18rem;
                color: #FABD01;
            }
    }
</style>
